import { Type } from 'class-transformer';
import { DimensionSelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/dimensions/dimension-selector-result-dto';
import { GLAccountSelectorResultDto } from '../../cirabooks/shared-cirabooks-module/_models/common/gl-account/glaccount-selector-result-dto';
import { VendorHeaderTemplateRawDto } from './vendor-header-template-raw-dto';
import { VendorLineItemCodingTemplateRawDto } from './vendor-line-item-coding-template-raw-dto';
import { WFEBankAccountResultDto } from './wfe-bank-account-result-dto';
import { WFESpecialHandlingResultDto } from './wfe-special-handling-result-dto';

export class VendorCodingDefaultEditorResultDto {
    @Type(() => WFESpecialHandlingResultDto)
    specialHandlings: Array<WFESpecialHandlingResultDto>;

    @Type(() => WFEBankAccountResultDto)
    bankAccounts: Array<WFEBankAccountResultDto>;

    @Type(() => GLAccountSelectorResultDto)
    glAccounts: Array<GLAccountSelectorResultDto>;

    @Type(() => DimensionSelectorResultDto)
    dimensions: Array<DimensionSelectorResultDto>;

    @Type(() => VendorLineItemCodingTemplateRawDto)
    lineItemTemplates: Array<VendorLineItemCodingTemplateRawDto>;

    @Type(() => VendorHeaderTemplateRawDto)
    headerTemplate: VendorHeaderTemplateRawDto;

    entityUsesSubcategory: boolean;
}
